export const sushi = {
  seo: {
    title: 'Case: De Wethouder Food & Drink Club | Bistroo',
    description: 'Lies, wie De Wethouder Food & Drink Club mit Bistroo einen zuverlässigen Online-Partner fand.',
  },
  hero: {
    title: 'Lies, wie De Wethouder einen zuverlässigen Online-Partner in Bistroo fand',
    description:
      'De Wethouder Food & Drink Club ist ein trendiges Etablissement im ehemaligen Rathaus von Denekamp. Sie bieten ein abwechslungsreiches Menü an, mit dem einzigartigen Walking-Dinner-Konzept als Highlight.',
  },
  testimonials: {
    1: {
      text: '"Mit Bistroos Bestelllösung konnten wir Bestellungen genau verarbeiten und deren Abwicklung verwalten. Dies führte zu weniger Fehlern und verbesserter Kundenzufriedenheit"',
      name: 'Ben Schulte',
      job_title: 'Chef',
    },
    2: {
      text: '"Die Nutzung von Bistroo für den Verkauf von Sushi to go erwies sich als besonders erfolgreich und effizient, was zu einem besseren Service und einem verbesserten Kundenerlebnis beigetragen hat. Das hätten wir sonst nie gewusst!"',
      name: 'Edwin ter Haar',
      job_title: 'Operativ verantwortlich',
    },
  },
  challenge: {
    paragraph: {
      title: 'Nachhaltige Zusammenarbeit',
      text: 'Neben ihrem Dine-in-Erlebnis bieten sie auch Sushi to go an, ein beliebtes Angebot, das über Bistroo verkauft wird. De Wethouder arbeitet seit über 2 Jahren mit Bistroo zusammen und berichtet kurz über die Herausforderungen, die sie vor der Zusammenarbeit hatten, und die Lösungen, die Bistroo bietet.',
    },
    paragraph_2: {
      title: 'Die Herausforderung',
      bullets: {
        1: 'In Stoßzeiten wurde De Wethouder Food & Drink Club mit Bestellungen überflutet, wodurch das Personal überlastet wurde und Kunden länger warten mussten.',
        2: 'Die Verwaltung von Bestellungen und deren Abwicklung war eine Herausforderung, insbesondere in Stoßzeiten.',
        3: 'Es war von entscheidender Bedeutung sicherzustellen, dass Bestellungen korrekt verarbeitet wurden, um Fehler zu minimieren und Kundenzufriedenheit zu gewährleisten.',
      },
    },
  },
  solution: {
    title: 'Die Lösung',
    checklist: {
      1: "Dank Bistroos Online-Bestelllösung konnte De Wethouder Food & Drink Club ihr Sushi-to-go-Angebot einfach und effizient verwalten. Kunden konnten problemlos online bestellen und abholen, wodurch der Prozess optimiert wurde.",
      2: "Mit Bistroos Bestelllösung konnte De Wethouder | Food & Drink Club Bestellungen genau verarbeiten und deren Abwicklung verwalten. Dies führte zu weniger Fehlern und verbesserter Kundenzufriedenheit.",
      3: 'Bistroo bot De Wethouder | Food & Drink Club Flexibilität und Anpassungsfähigkeit, sodass sie schnell auf veränderte Bedürfnisse und neue Möglichkeiten eingehen konnten, wie den Verkauf von Sushi to go.',
    },
  },
  conclusion: {
    title: 'Das Fazit',
    text: {
      1: "Dank Bistroos Online-Bestelllösung konnte De Wethouder Food & Drink Club nicht nur ihre betriebliche Effizienz verbessern, sondern auch ihre Kundenzufriedenheit erhöhen und Wachstumsmöglichkeiten nutzen. Die Nutzung von Bistroo für den Verkauf von Sushi to go erwies sich als besonders erfolgreich und effizient, was zu einem besseren Service und einem verbesserten Kundenerlebnis beigetragen hat. Bistroo zeichnet sich durch seine Gastfreundschaft aus, bei der aktiv über Lösungen und neue Möglichkeiten für De Wethouder Food & Drink Club nachgedacht wird. Dieser lokale Ansatz schafft ein starkes Vertrauensverhältnis und stärkt die Zusammenarbeit zwischen beiden Parteien.",
      2: 'Außerdem steht Bistroo rund um die Uhr für De Wethouder Food & Drink Club bereit, unabhängig vom Zeitpunkt. Diese kontinuierliche Unterstützung gibt dem Restaurant Sicherheit und Vertrauen in seinen Online-Bestellprozess. De Wethouder | Food & Drink Club empfiehlt Bistroo ausdrücklich anderen Gastronomiebetrieben, die nach einer flexiblen und effizienten Online-Bestelllösung suchen.',
    },
  },
}
